<h1 mat-dialog-title>Nueva doble transferencia</h1>
<div mat-dialog-content>
  <form [formGroup]="dobleForm">
    <p style="color: black; font-weight: bold">1ª Transferencia:</p>
    <br />
    <div class="row">
      <mat-form-field appearance="outline" class="col-lg-4 col-md-6 col-sm-12">
        <mat-label>Tipo de Trámite</mat-label>
        <select matInput matNativeControl formControlName="tipoTramite">
          <option label="--Seleccionar--"></option>
          <option value="Transferencia">Transferencia</option>
          <option value="CAMBIO DE PROPIEDAD TURISMO">Cambio de Propiedad Turismo</option>
          <option value="CAMBIO DE PROPIEDAD VEHICULO INDUSTRIAL">Cambio de Propiedad Vehículo Industrial</option>
          <option value="CAMBIO DE PROPIEDAD VEHICULO ESPECIAL">Cambio de Propiedad Vehículo Especial</option>
          <option value="CAMBIO DE PROPIEDAD MOTOCICLETA">Cambio de Propiedad Motocicleta</option>
          <option value="CAMBIO DE PROPIEDAD CICLOMOTOR">Cambio de Propiedad Ciclomotor</option>
          <option value="Notificación de venta a particular">
            Notificación Venta Particular
          </option>
          <option value="NOTIFICACION VENTA TURISMO">Notificación Venta Turismo</option>
          <option value="NOTIFICACION VENTA INDUSTRIAL">Notificación Venta Industrial</option>
          <option value="NOTIFICACION VENTA ESPECIAL">Notificación Venta Especial</option>
          <option value="NOTIFICACION VENTA MOTOCICLETA">Notificación Venta Motocicleta</option>
          <option value="NOTIFICACION VENTA CICLOMOTOR">Notificación Venta Ciclomotor</option>
        </select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="col-lg-4 col-md-6 col-sm-12">
        <mat-label>Nº factura de compra</mat-label>
        <input
          matInput
          matNativeControl
          type="text"
          formControlName="nroCompra"
        />
      </mat-form-field>
      <mat-form-field appearance="outline" class="col-lg-4 col-md-6 col-sm-12">
        <mat-label>Precio de compra</mat-label>
        <input
          matInput
          matNativeControl
          type="text"
          formControlName="baseImponibleCompra"
        />
      </mat-form-field>
    </div>
    <br />
    <p style="color: black; font-weight: bold">2ª Transferencia:</p>
    <br />
    <div class="row">
      <mat-form-field appearance="outline" class="col-lg-4 col-md-6 col-sm-12">
        <mat-label>Tipo de Trámite</mat-label>
        <select matInput matNativeControl formControlName="tipoTramiteD">
          <option label="--Seleccionar--"></option>
          <option value="Transferencia">Transferencia</option>
          <option value="CAMBIO DE PROPIEDAD TURISMO">Cambio de Propiedad Turismo</option>
          <option value="CAMBIO DE PROPIEDAD VEHICULO INDUSTRIAL">Cambio de Propiedad Vehículo Industrial</option>
          <option value="CAMBIO DE PROPIEDAD VEHICULO ESPECIAL">Cambio de Propiedad Vehículo Especial</option>
          <option value="CAMBIO DE PROPIEDAD MOTOCICLETA">Cambio de Propiedad Motocicleta</option>
          <option value="CAMBIO DE PROPIEDAD CICLOMOTOR">Cambio de Propiedad Ciclomotor</option>
          <option value="Notificación de venta a particular">
            Notificación Venta Particular
          </option>
          <option value="NOTIFICACION VENTA TURISMO">Notificación Venta Turismo</option>
          <option value="NOTIFICACION VENTA INDUSTRIAL">Notificación Venta Industrial</option>
          <option value="NOTIFICACION VENTA ESPECIAL">Notificación Venta Especial</option>
          <option value="NOTIFICACION VENTA MOTOCICLETA">Notificación Venta Motocicleta</option>
          <option value="NOTIFICACION VENTA CICLOMOTOR">Notificación Venta Ciclomotor</option>
        </select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="col-lg-4 col-md-6 col-sm-12">
        <mat-label>Nº factura de venta</mat-label>
        <input
          matInput
          matNativeControl
          type="text"
          formControlName="nroVentas"
        />
      </mat-form-field>
      <mat-form-field appearance="outline" class="col-lg-4 col-md-6 col-sm-12">
        <mat-label>Precio de venta</mat-label>
        <input
          matInput
          matNativeControl
          type="text"
          formControlName="baseImponible"
        />
      </mat-form-field>
    </div>
    <br />
    <div class="row">
      <mat-form-field appearance="outline" class="col-lg-4 col-md-6 col-sm-12">
        <mat-label>Número de pedido</mat-label>
        <input
          matInput
          matNativeControl
          type="text"
          formControlName="numPedido"
        />
      </mat-form-field>
    </div>
  </form>
</div>
<mat-dialog-actions align="end">
  <button mat-button mat-dialog-close>Cancelar</button>
  <button
    mat-button
    [disabled]="dobleForm.invalid"
    [mat-dialog-close]="dobleForm"
  >
    Siguiente
  </button>
</mat-dialog-actions>
